<template>
  <div class="form-group" v-if="labelPosition == 'left'">
    <label v-if="label" :for="name" class="col-form-label col-md-3 col-xl-2 col-sm-12">
      {{ label }} <span v-if="required" class="text-danger">*</span>
    </label>

    <input
      type="text"
      class="form-control"
      :class="{ 'is-invalid': error }"
      :id="name"
      :name="name"
      :list="`${name}-time-options`"
      v-model="displayValue"
      @blur="onBlur"
      @input="onInput"
      :required="required"
    >
    <datalist :id="`${name}-time-options`">
      <option v-for="option in dropdownOptions" :key="option">{{ option }}</option>
    </datalist>

    <div class="invalid-feedback" v-if="error">
      {{ error }}
    </div>
  </div>
  <div class="form-group d-flex align-items-start flex-wrap" v-else>
    <div class="input-container">
        <input
          type="text"
          class="form-control"
          :class="{ 'is-invalid': error }"
          :id="name"
          :name="name"
          :list="`${name}-time-options`"
          v-model="displayValue"
          @blur="onBlur"
          @input="onInput"
          :required="required"
        >
        <datalist :id="`${name}-time-options`">
          <option v-for="option in dropdownOptions" :key="option">{{ option }}</option>
        </datalist>

        <div class="invalid-feedback" v-if="error">
          {{ error }}
        </div>
    </div>  

    <label
      v-if="label"
      :for="name"
      class="form-label me-3 ml-2 col-form-label"
    >
    {{ label }} <span v-if="required" class="">*</span>
    </label>
    
  </div>
</template>

<script>
export default {
  name: "TimeInput",
  props: {
    value: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    labelPosition: {
      type: String,
      default: 'left',
      validator: value => ['left', 'right'].includes(value),
    },
  },
  data() {
    return {
      displayValue: '',
    };
  },
  computed: {
    dropdownOptions() {
      const options = [];
      for (let h = 0; h <= 10; h++) {
        options.push(`${h}:00`);
        if (h !== 10) options.push(`${h}:30`);
      }
      return options;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal != null && !isNaN(newVal)) {
          const hours = Math.floor(newVal);
          const minutes = Math.round((newVal - hours) * 60);
          this.displayValue = `${hours}:${minutes.toString().padStart(2, '0')}`;
        } else {
          this.displayValue = '';
        }
      }
    }
  },
  methods: {
    onBlur() {
      const match = this.displayValue.match(/^(\d{1,2}):(\d{2})$/);
      if (match) {
        const hours = parseInt(match[1], 10);
        const minutes = parseInt(match[2], 10);
        const decimal = hours + minutes / 60;
        this.$emit('input', parseFloat(decimal.toFixed(2)));
      } else {
        this.displayValue = '';
        this.$emit('input', null);
      }
    },
    onInput(e) {
      this.displayValue = e.target.value;
    }
  }
}
</script>

<style scoped>
.form-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.form-label {
  max-width: 80%;
  flex: 1 1 auto;
  align-self: center;
  /* margin-bottom: 0.5rem; */
  line-height: 1.3em;
  font-weight: 400;
}

.input-container {
  flex: 0 0 auto;
  max-width: 80px;
  width: 100%;
}

.form-control {
  width: 100%;
}

/* The arrow icon is misaligned due to parent issues, so better to just hide the native picker 
icon and draw your own chevron as a background that’s always centered vertically */

/* Make room for the icon and add a custom chevron that's always centered */
.form-control[list] {
  /* keep sizing - just ensure room on the right */
  padding-right: 2rem;

  /* custom arrow (inline SVG) — vertically centered by background-position */
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='currentColor' d='M4.646 6.646a.5.5 0 0 1 .708 0L8 9.293l2.646-2.647a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 0.65rem center; /* centers vertically */
  background-size: 1rem auto;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* Hide the native indicator but keep it clickable for accessibility in WebKit */
.form-control[list]::-webkit-calendar-picker-indicator {
  opacity: 0;           /* visually hidden */
  position: absolute;   /* keep it clickable */
  right: 0.25rem;
  width: 2rem;
  height: 100%;
  cursor: pointer;
}

/* Clean up platform-specific extras */
.form-control[list]::-ms-clear,
.form-control[list]::-ms-reveal {
  display: none;
}
</style>